import React from "react";

const WhiteSpace = ({ data }) => {
  return (
    <>
      <div
        style={{ height: `${data["desktop-space"]}px` }}
        className="hidden md:block"
      />
      <div
        style={{ height: `${data["mobile-space"]}px` }}
        className="md:hidden"
      />
    </>
  );
};

export default WhiteSpace;
